import { datadogRum } from '@datadog/browser-rum';
import { AUTH_SESSION_START, LOG_OUT } from 'stash/actions';
import { isProdOrStaging } from 'stash/utils';

const middleware = () => (next) => (action) => {
	if (isProdOrStaging()) {
		switch (action.type) {
			case AUTH_SESSION_START:
				datadogRum.setUser({ id: action.uuid });
				break;
			case LOG_OUT:
				datadogRum.setUser({ id: null });
				break;
			default:
		}
	}

	return next(action);
};

export default middleware;
